<template>
  <b-row>
    <b-col cols="12" xl="12">
      <users-search-form
        @change="onSearchResult"
        @click="onSearchClick"
      ></users-search-form>
    </b-col>
    <b-col cols="12" xl="6">
      <transition name="slide">
        <b-card>
          <div slot="header">
            <strong>Users</strong>
          </div>
          <pagination-table
            :items="users"
            :pagination="pagination"
            :fields="[
              {key: 'name'},
              {key: 'surname'},
              {key: 'email'},
              {key: 'actions'},
            ]"
            :is-loading="isLoading"
            base-url="users?"
            item-url="users/{id}"
          ></pagination-table>
        </b-card>
      </transition>
    </b-col>
    <b-col cols="12" xl="6">
      <flash-message transitionIn="animated swing"></flash-message>
      <b-card>
        <div slot="header">
          <strong>User</strong>
        </div>
        <user-form :add-option="true"></user-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>

  import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
  import {PaginationMeta} from "../../models/PaginationMeta";
  import UserForm from "../../components/users/UserForm";
  import PaginationTable from "../../components/base/PaginationTable";
  import UsersSearchForm from "../../components/users/UsersSearchForm";

  export default {
      name: 'Users',
      components: {
        UsersSearchForm,
        PaginationTable,
        UserForm,
      },
      data() {
        return {
            pagination: new PaginationMeta(),
            users: new Array(),
            isLoading: true,
        }
      },
      created() {
        RepositoryFactory
          .get('user')
          .get()
          .then(
            response => {
              this.users = response.data.data;
              this.pagination = response.data.meta;
              this.isLoading = false;
            }
          )
      },
      methods: {
          onSearchResult(response) {
              this.users = response.data,
              this.pagination = response.meta,
              this.isLoading = false
          },
          onSearchClick() {
              this.isLoading = true
          },
      }
  }
</script>
